.bz{max-width:100%;}